<template>
  <v-container class="d-flex flex-column h-full">
    <h1>Internal Admin</h1>

    <p>Select a link from the nav on the left</p>
  </v-container>
</template>
